import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  ICustomer,
  IListCustomersSlice,
  LIST_CUSTOMERS_SLICE,
} from "./customers.constant";
import { onAddCustomer, onGetListCustomer, onUpdateCustomer } from "./customers.thunk";

const initialState: IListCustomersSlice = {
  customers: [],
  isGot: false,
};
export const customersSlice = createSlice({
  name: LIST_CUSTOMERS_SLICE,
  initialState,
  reducers: {
    getListCustomer: (state, action: PayloadAction<ICustomer[]>) => {
      const data = action.payload;
      state.customers = data;

      state.isGot = true;
    },
    addCustomer: (state, action: PayloadAction<ICustomer>) => {
      const newUser = action.payload;
      state.customers.push(newUser);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      onGetListCustomer.fulfilled,
      (state, action: PayloadAction<ICustomer[]>) => {
        const data = action.payload;
        state.customers = data;
        state.isGot = true;
      }
    );
    builder.addCase(onGetListCustomer.rejected, (state) => {
      state.customers = [];
      state.isGot = false;
    });
    builder.addCase(onAddCustomer.fulfilled, (state, action) => {
      state.customers.push(action.payload);
    });
    builder.addCase(onAddCustomer.rejected, (state) => {
      console.error("❌ Thêm khách hàng thất bại");
    });

    // ✅ Cập nhật khách hàng
    builder.addCase(onUpdateCustomer.fulfilled, (state, action) => {
      const updated = action.payload;
      const index = state.customers.findIndex((c) => c._id === updated._id);
      if (index !== -1) state.customers[index] = updated;
    });
    builder.addCase(onUpdateCustomer.rejected, (state) => {
      console.error("❌ Cập nhật khách hàng thất bại");
    });
  },
});
export default customersSlice.reducer;
